import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Grid, Avatar } from "@mui/material";
import { BrowserView, isBrowser, isMobile, MobileView } from "react-device-detect";
import { useTheme } from "@emotion/react";
import Popup from "./Popup.js";
import { useProject } from "../../hook/useProject.js";
import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";
import { useUser } from "../../hook/useUser.js";
import { grey } from "@mui/material/colors";

const Title = ({ children, xs = 12 }) => {
  const theme = useTheme();
  return (
    <Grid item xs={xs}>
      <Typography color={grey[600]}>{children}</Typography>
    </Grid>
  );
};

const Content = ({ children, xs = 12 }) => {
  return (
    <Grid item xs={xs} sx={{ pt: "0 !important" }}>
      <Typography>{children}</Typography>
    </Grid>
  );
};

const MyProfilePopup = ({ open, onClose }) => {
  const theme = useTheme();
  const { user } = useUser();
  const navigate = useNavigate();
  const [confirmLogout, setConfirmLogout] = useState(false);

  const logout = () => {
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("refreshToken");
    window.localStorage.removeItem("exp");
    setConfirmLogout(false);
    onClose();
    navigate(`/`);
  };

  return (
    <>
      <Popup open={open} onClose={onClose} noModal isExpanded={true}>
        <Box p={4}>
          <Grid container spacing={1}>
            <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
              <Avatar sx={{ width: 60, height: 60, bgcolor: theme.palette.primary.main, fontSize: 30 }}>
                {user?.firstName?.charAt(0)}
                {user?.lastName?.charAt(0)}
              </Avatar>
            </Grid>
            <Grid item>
              <Typography sx={{ fontWeight: 500 }}>My Profile</Typography>
            </Grid>
            <Title>First Name</Title>
            <Content>{user?.firstName}</Content>
            <Title>Last Name</Title>
            <Content>{user?.lastName}</Content>
            <Title>Email</Title>
            <Content>{user?.email}</Content>
            <Title>User Role</Title>
            <Content>{user?.userRole}</Content>
            <Title>Position</Title>
            <Content>{user?.position}</Content>
            <Title>Company</Title>
            <Content>{user?.company}</Content>
          </Grid>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
            <Button variant="contained" color="secondary" sx={{ width: "100%", mt: 2, borderRadius: "10px" }} onClick={() => setConfirmLogout(true)}>
              Log out
            </Button>
          </Grid>
        </Box>
      </Popup>
      <Popup open={confirmLogout}>
        <Grid container spacing={1} sx={{ padding: 3 }}>
          <Grid item>
            <Typography>Confirm to log out the account?</Typography>
          </Grid>
          <Grid item xs={6}>
            <Button variant="contained" color="secondary" sx={{ width: "100%", borderRadius: "5px" }} onClick={() => logout()}>
              Yes
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant="contained"
              sx={{ width: "100%", borderRadius: "5px", backgroundColor: "#717273" }}
              onClick={() => setConfirmLogout(false)}
            >
              No
            </Button>
          </Grid>
        </Grid>
      </Popup>
    </>
  );
};

export default MyProfilePopup;
